var render, staticRenderFns
import script from "./AuctionInfo.vue?vue&type=script&lang=js&"
export * from "./AuctionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be72114",
  null
  
)

export default component.exports